// ─── COOKIE CONSENT BANNER ────────────────────────────────────────────────────
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CONSENT_KEY = 'mgm_cookie_consent';

export function useCookieConsent() {
  const [consented, setConsented] = useState(() => {
    return localStorage.getItem(CONSENT_KEY) === 'yes';
  });

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'yes');
    setConsented(true);
  }

  return { consented, accept };
}

export default function CookieBanner({ lang }) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const isAr = lang === 'ar';

  useEffect(() => {
    // Show after a short delay so it doesn't flash on first paint
    const timer = setTimeout(() => {
      if (localStorage.getItem(CONSENT_KEY) !== 'yes') {
        setVisible(true);
      }
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'yes');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      dir={isAr ? 'rtl' : 'ltr'}
      style={{
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'calc(100% - 32px)',
        maxWidth: 560,
        background: 'rgba(18,14,28,0.97)',
        border: '1px solid rgba(255,209,102,0.2)',
        borderRadius: 14,
        padding: '16px 20px',
        display: 'flex',
        gap: 16,
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        zIndex: 9999,
        boxShadow: '0 8px 40px rgba(0,0,0,0.5)',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div style={{ flex: 1, minWidth: 220 }}>
        <p style={{ margin: 0, fontSize: '0.82rem', color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
          🍪{' '}
          {isAr
            ? 'بنستخدم كوكيز أساسية وGoogle Fonts. باستخدامك للموقع، بتوافق.'
            : 'We use essential cookies and Google Fonts. By continuing, you agree.'}
          {' '}
          <button
            onClick={() => navigate('/privacy')}
            style={{
              background: 'none', border: 'none', color: '#FFD166',
              cursor: 'pointer', fontSize: '0.82rem', padding: 0,
              textDecoration: 'underline', fontFamily: 'inherit'
            }}
          >
            {isAr ? 'اقرأ أكتر' : 'Learn more'}
          </button>
        </p>
      </div>
      <button
        onClick={accept}
        style={{
          background: '#FFD166', color: '#0D0A14', border: 'none',
          borderRadius: 8, padding: '8px 20px', fontWeight: 700,
          fontSize: '0.82rem', cursor: 'pointer', whiteSpace: 'nowrap',
          fontFamily: 'inherit'
        }}
      >
        {isAr ? 'موافق ✓' : 'Got it ✓'}
      </button>
    </div>
  );
}
